interface FormatDateTimeOptions {
  date: string | Date
  pattern?: string
  locale?: string
}

export const formatDateTime = (options: FormatDateTimeOptions | string): string => {
  let timestamp: string | Date
  let pattern: string | undefined
  let locale: string | undefined

  if (typeof options === 'string') {
    timestamp = options
    pattern = undefined
    locale = undefined
  } else {
    timestamp = options.date
    pattern = options.pattern
    locale = options.locale
  }

  const now = new Date()
  let date = now
  
  if (timestamp) {
    date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp
  }

  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }

  // Determine locale - default to 'en-US' if not provided
  const resolvedLocale = locale || 'en-US'

  if (pattern === 'PPP') {
    return date.toLocaleDateString(resolvedLocale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  // For backward compatibility, return localized short date format
  return date.toLocaleDateString(resolvedLocale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
}
